@if (i18nToolingEnabled) {
    <div class="btn-group" data-i18n-mc-ui>
        <button
            class="navbar-button"
            [class.on]="missCatcher.isCapturing"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            aria-label="i18n tools"
        >
            <i class="fal fa-globe"></i>
        </button>
        <ul class="dropdown-menu dropdown-menu-end">
            <li class="dropdown-header">i18n miss-catcher</li>
            <li>
                <button type="button" class="dropdown-item" (click)="missCatcher.toggle()">
                    <span class="icon">
                        <i
                            class="far"
                            [class.fa-eye]="!missCatcher.isCapturing"
                            [class.fa-eye-slash]="missCatcher.isCapturing"
                        ></i>
                    </span>
                    <span class="text">{{ missCatcher.isCapturing ? "Stop capturing" : "Start capturing" }}</span>
                </button>
            </li>
            <li class="dropdown-item-text">{{ missCatcher.count }} captured</li>
            <li>
                <button type="button" class="dropdown-item" (click)="missCatcher.export()">
                    <span class="icon"><i class="far fa-download"></i></span>
                    <span class="text">Export JSON</span>
                </button>
            </li>
            @if (observability.sentryEnabled()) {
                <li>
                    <button type="button" class="dropdown-item" (click)="submitToSentry()">
                        <span class="icon"><i class="far fa-paper-plane"></i></span>
                        <span class="text">Submit to Sentry</span>
                    </button>
                </li>
            }
            <li>
                <button type="button" class="dropdown-item" (click)="missCatcher.clearAll()">
                    <span class="icon"><i class="far fa-trash"></i></span>
                    <span class="text">Clear</span>
                </button>
            </li>
            <li><hr class="dropdown-divider" /></li>
            <li>
                <button type="button" class="dropdown-item" (click)="togglePseudo()">
                    <span class="icon">
                        @if (pseudoEnabled) {
                            <i class="far fa-check"></i>
                        }
                    </span>
                    <span class="text">Enable pseudo</span>
                </button>
            </li>
        </ul>
    </div>
}
